import React from 'react';
import Styles from './styles.js';

const HeadingSection = ({ title,mb,mt }) => {
    return (
        <div className='lg:container  mx-auto  px-4 '>
            <h2 className={`BUS-head-title ${mb} ${mt} font-normal border-b-2 pb-3 mb-10 `}>
                {title}
            </h2>
            <Styles/>

        </div>
    );
};

export default HeadingSection;
